import { render, staticRenderFns } from "./gasStationAdd.vue?vue&type=template&id=27c90bf2&scoped=true"
import script from "./gasStationAdd.vue?vue&type=script&lang=js"
export * from "./gasStationAdd.vue?vue&type=script&lang=js"
import style0 from "./gasStationAdd.vue?vue&type=style&index=0&id=27c90bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c90bf2",
  null
  
)

export default component.exports